export default __webpack_public_path__ + "static/media/back2.63323484.png";